import React from 'react'

export default function GetUrl() {

    //return "https://boxy.currenmexico.com/legalback/" // Produccion

    // https://mxgsesoftware.com/digactiva/

    return "https://mxgsesoftware.com/digactiva/" // desarollo
    
}
